import Vue from 'vue';
import '@/styles/root-tokens.scss';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import './plugins/axios'; // Axios interceptors'ı yükle

// Global Components
import Icon from './components/Icon.vue';
import Checkbox from './components/Checkbox.vue';
import MankTextField from './components/MankTextField.vue';
import MankSelect from './components/MankSelect.vue';
import MankTextarea from './components/MankTextarea.vue';

Vue.component('Icon', Icon);
Vue.component('Checkbox', Checkbox);
Vue.component('MankTextField', MankTextField);
Vue.component('MankSelect', MankSelect);
Vue.component('MankTextarea', MankTextarea);

Vue.config.productionTip = false;

// Uygulama başlatılırken auth state'i initialize et
store.dispatch('auth/initializeAuth');

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
